// extracted by mini-css-extract-plugin
export default {"wrapper":"r0Ga6J","showOptions":"jKHR7X","confirmIcon":"WzjRc7","cancelIcon":"HVo2oV","deleteIcon":"LupEQa"};